module.exports = __webpack_public_path__ + "img/2.2010f791.png";